import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { callApiSaqsFind } from "../services";
import { authUserData } from "../helpers";

class BusinessAdminHeader extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { userType: null, draftSaqData: [], completedSaqData: [] };
  }

  componentDidMount = async () => {
    const hostname = window.location.hostname;

    // Split by dots
    const parts = hostname.split(".");

    // Get the subdomain (first part)
    const subdomain = parts[0];
    const userData = authUserData();

    if (userData && userData.userType) {
      this.setState({
        userType: userData.userType,
      });
    }

    // console.log("useData Dashboard", userData.userId);

    /* const tempPassword = await this.makeTempPassword();
    const userId = userData && userData.userId;
    callApiUpdateUserPassword(userId, { password: tempPassword }).then(
      (resData) => {
        
      }
    ); */

    let saqsApiParam = null;

    /* if (userData && userData.isAdmin && userData.isAdmin === true) {
      saqsApiParam = { isAdmin: true };
    } else {
      saqsApiParam = { data: subdomain };
    } */

    if (
      userData &&
      userData.isAdmin &&
      userData.isAdmin === true &&
      subdomain === "app"
    ) {
      saqsApiParam = {}; // Empty query to get all SAQs
      console.log("Dashboard - Using empty query for admin on app subdomain");
    } else {
      saqsApiParam = { subdomain: subdomain }; // Filter by subdomain
      console.log("Dashboard - Using subdomain filter:", saqsApiParam);
    }

    callApiSaqsFind(saqsApiParam)
      .then((res) => {
        // console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });

          // console.log("completedList", completedList);

          this.setState({
            draftSaqData: draftList,
            completedSaqData: completedList,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  render() {
    const { isBusinessAdmin } = this.state;
    const { userType, draftSaqData, completedSaqData } = this.state;
    return (
      <div className="grid-x grid-margin-x">
        <div id="header" className="cell small-12">
          <ul className="menu simple">
            <li>
              <Link to="/control-panel/draft-saqs">
                Drafts{" "}
                <span className="bubble-notif">
                  {draftSaqData && draftSaqData.length}
                </span>
                <i className="triangle"></i>
              </Link>
            </li>
            <li>
              <Link to="/control-panel/completed-saqs">
                Completed SAQs{" "}
                <span className="bubble-notif">
                  {completedSaqData && completedSaqData.length}
                </span>
                <i className="triangle"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessAdminHeader);
